module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/prong-dark-bgimage.04356a04.svg";